if (!window.customElements.get("scrollable-content")) {
  class ScrollableContent extends HTMLElement {
    connectedCallback() {
      this._checkScrollability(),
        window.addEventListener("resize", this._checkScrollability.bind(this)),
        this.addEventListener(
          "scroll",
          window.throttle(this._calculateProgress.bind(this), 15)
        );
    }
    get draggable() {
      return this.hasAttribute("draggable");
    }
    _checkScrollability() {
      this.classList.toggle(
        "is-scrollable",
        this.scrollWidth > this.offsetWidth
      );
    }
    _calculateProgress() {
      const scrollLeft = this.scrollLeft * 1;
      const progress = Math.max(0, Math.min(1, scrollLeft / (this.scrollWidth - this.clientWidth))) * 100;
      this.dispatchEvent(new CustomEvent("scrollable-content:progress", {
        bubbles: true,
        detail: {
          progress,
        }
      }));
    }
    _onMouseDown(event) {
      event.target && event.target.nodeName === "IMG" && event.preventDefault(),
        (this.startX = event.clientX + this.scrollLeft),
        (this.diffX = 0),
        (this.drag = !0);
    }
    _onMouseMove(event) {
      this.drag &&
        ((this.diffX = this.startX - (event.clientX + this.scrollLeft)),
        (this.scrollLeft += this.diffX));
    }
    _onMouseUp() {
      this.drag = !1;
      let start = 1,
        animate = () => {
          let step = Math.sinh(start);
          step <= 0
            ? window.cancelAnimationFrame(animate)
            : ((this.scrollLeft += this.diffX * step),
              (start -= 0.03),
              window.requestAnimationFrame(animate));
        };
      animate();
    }
  }

  window.customElements.define("scrollable-content", ScrollableContent);
}
